import * as React from 'react';
import { useContext, useState } from 'react';

import { makeStyles } from 'tss-react/mui';

import { DateTime } from 'luxon';
import DateRow from './DateRow';
import { FrequencyContext } from './state';

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

function MultipleDates() {
  const { state, dispatch, error } = useContext(FrequencyContext);
  const { classes } = useStyles();
  const [showEmptyRow, setShowEmptyRow] = useState(false);

  const values = state?.byDates ? [...state.byDates] : [];
  if (values.length === 0 && !showEmptyRow) {
    setShowEmptyRow(true);
  }

  // @ts-expect-error FIXME TS7006
  const handleChangeDate = (date, index) => {
    if (index >= 0) {
      const newValues = Object.assign([], values, { [index]: date });
      dispatch({ type: 'UPDATE_MULTIPLE_BY_DATES', payload: newValues });
      setShowEmptyRow(false);
    }
  };

  const handleAddNewDate = (date: string) => {
    const newValues = [...values, date];
    dispatch({ type: 'UPDATE_MULTIPLE_BY_DATES', payload: newValues });
    setShowEmptyRow(false);
  };

  const handleDeleteDate = (removeDate: string) => {
    const newValues = values.filter((item) => item !== removeDate);
    dispatch({ type: 'UPDATE_MULTIPLE_BY_DATES', payload: newValues });
    setShowEmptyRow(false);
  };

  const handleShowEmptyRow = () => {
    setShowEmptyRow(true);
  };

  return (
    <div id='multiple-days-recurrence' className={classes.root}>
      {values?.length > 0 &&
        values.map((value, index) => (
          <DateRow
            key={value}
            value={value}
            dueOn={state.dueOn || DateTime.now()}
            onChange={(date) => handleChangeDate(date, index)}
            onAdd={values.length - 1 === index && !showEmptyRow ? handleShowEmptyRow : undefined}
            onDelete={handleDeleteDate}
            error={false}
          />
        ))}

      {showEmptyRow && (
        <DateRow
          key='empty'
          value={null}
          dueOn={state.dueOn || DateTime.now()}
          onChange={handleAddNewDate}
          error={error}
          onAdd={undefined}
          onDelete={undefined}
        />
      )}
    </div>
  );
}

export default MultipleDates;
